module.exports = __webpack_public_path__ + "img/premium-invoice.71441c6f.png";